/**
 * Add New Lead Profile
 */

import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";

import TxtRow from "components/Custom/TxtRow";
import Btn from "components/Custom/Btn";

import { LABELS, SUCCESS, WARNINGS } from "common/lables";
import { COLORS } from "common/colors";
import { CRM_APIs } from "apihandlers/crm";
import { COMMON_JS } from "common/scripts";
import { CONFIG, CRM_LEAD_STATUS, NOTIFY } from "common/config";
import AutoComplete from "components/Custom/AutoComplete";

interface defaultProps {}

const NewLeadProfile = (props: any) => {
  const { setManageNewDialog, selectedRow, areas, onClose } = props;
  const areasRef: any = useRef(null);

  const saveRrecord = async () => {
    try {
      //Current Details
      const fName = (
        document.getElementById("fName") as HTMLInputElement
      ).value.trim();
      const midName = (
        document.getElementById("midName") as HTMLInputElement
      ).value.trim();
      const lName = (
        document.getElementById("lName") as HTMLInputElement
      ).value.trim();
      const state = (
        document.getElementById("state") as HTMLInputElement
      ).value.trim();
      const district = (
        document.getElementById("district") as HTMLInputElement
      ).value.trim();
      const taluk = (
        document.getElementById("taluk") as HTMLInputElement
      ).value.trim();
      const appDate = (
        document.getElementById("appDate") as HTMLInputElement
      ).value.trim();
      const dob = (
        document.getElementById("dob") as HTMLInputElement
      ).value.trim();
      const currentAdd = (
        document.getElementById("currentAdd") as HTMLInputElement
      ).value.trim();

      //Personal Details
      const pState = (
        document.getElementById("pState") as HTMLInputElement
      ).value.trim();
      const pDist = (
        document.getElementById("pDist") as HTMLInputElement
      ).value.trim();
      const pTaluka = (
        document.getElementById("pTaluka") as HTMLInputElement
      ).value.trim();
      const phone = (
        document.getElementById("phone") as HTMLInputElement
      ).value.trim();
      const mob1 = (
        document.getElementById("mob1") as HTMLInputElement
      ).value.trim();
      const mob2 = (
        document.getElementById("mob2") as HTMLInputElement
      ).value.trim();
      const pin = (
        document.getElementById("pin") as HTMLInputElement
      ).value.trim();
      const age = (
        document.getElementById("age") as HTMLInputElement
      ).value.trim();

      //Company Details:
      const compName = (
        document.getElementById("compName") as HTMLInputElement
      ).value.trim();
      const compEmail = (
        document.getElementById("compEmail") as HTMLInputElement
      ).value.trim();
      const compAddress = (
        document.getElementById("compAddress") as HTMLInputElement
      ).value.trim();
      const compState = (
        document.getElementById("compState") as HTMLInputElement
      ).value.trim();
      const compDist = (
        document.getElementById("compDist") as HTMLInputElement
      ).value.trim();
      const compTaluka = (
        document.getElementById("compTaluka") as HTMLInputElement
      ).value.trim();
      const compPin = (
        document.getElementById("compPin") as HTMLInputElement
      ).value.trim();
      const firmType = (
        document.getElementById("firmType") as HTMLInputElement
      ).value.trim();
      const email = (
        document.getElementById("email") as HTMLInputElement
      ).value.trim();

      //Education Details
      const eduDetail = (
        document.getElementById("eduDetail") as HTMLInputElement
      ).value.trim();
      const eduSSC = (
        document.getElementById("eduSSC") as HTMLInputElement
      ).value.trim();
      const eduHSC = (
        document.getElementById("eduHSC") as HTMLInputElement
      ).value.trim();
      const eduGraduationCert = (
        document.getElementById("eduGraduationCert") as HTMLInputElement
      ).value.trim();
      const eduPostGraduationCert = (
        document.getElementById("eduPostGraduationCert") as HTMLInputElement
      ).value.trim();

      //Partner Details
      const partnerFName = (
        document.getElementById("partnerFName") as HTMLInputElement
      ).value.trim();
      const partnerMidName = (
        document.getElementById("partnerMidName") as HTMLInputElement
      ).value.trim();
      const partnerLName = (
        document.getElementById("partnerLName") as HTMLInputElement
      ).value.trim();
      const partnerState = (
        document.getElementById("partnerState") as HTMLInputElement
      ).value.trim();
      const partnerDist = (
        document.getElementById("partnerDist") as HTMLInputElement
      ).value.trim();
      const partnerTaluk = (
        document.getElementById("partnerTaluk") as HTMLInputElement
      ).value.trim();
      const partnerDOB = (
        document.getElementById("partnerDOB") as HTMLInputElement
      ).value.trim();
      const partnerCurrentAddress = (
        document.getElementById("partnerCurrentAddress") as HTMLInputElement
      ).value.trim();
      const partnerAge = (
        document.getElementById("partnerAge") as HTMLInputElement
      ).value.trim();
      const partnerPhone = (
        document.getElementById("partnerPhone") as HTMLInputElement
      ).value.trim();
      const partnerMob1 = (
        document.getElementById("partnerMob1") as HTMLInputElement
      ).value.trim();
      const partnerMob2 = (
        document.getElementById("partnerMob2") as HTMLInputElement
      ).value.trim();
      const partnerPin = (
        document.getElementById("partnerPin") as HTMLInputElement
      ).value.trim();

      //Experience Details
      const otherExp = (
        document.getElementById("otherExp") as HTMLInputElement
      ).value.trim();

      //Storage Details:
      const strgFacility = (
        document.getElementById("strgFacility") as HTMLInputElement
      ).value.trim();
      const transportFacility = (
        document.getElementById("transportFacility") as HTMLInputElement
      ).value.trim();
      const godownSize = (
        document.getElementById("godownSize") as HTMLInputElement
      ).value.trim();

      //Logistics Details:
      const vehicalDetails = (
        document.getElementById("vehicalDetails") as HTMLInputElement
      ).value.trim();

      //Capital Details
      const investmentCapacity = (
        document.getElementById("investmentCapacity") as HTMLInputElement
      ).value.trim();
      const workingCapital = (
        document.getElementById("workingCapital") as HTMLInputElement
      ).value.trim();

      const argsCurrent = {
        fName,
        midName,
        lName,
        state,
        district,
        taluk,
        appDate,
        dob,
        currentAdd,
      };
      const argsPersonal = {
        pState,
        pDist,
        pTaluka,
        phone,
        mob1,
        mob2,
        pin,
        age,
      };
      const argsCompany = {
        compName,
        compEmail,
        compAddress,
        compState,
        compDist,
        compTaluka,
        compPin,
        firmType,
        email,
      };
      const argsEducational = {
        eduDetail,
        eduSSC,
        eduHSC,
        eduGraduationCert,
        eduPostGraduationCert,
      };
      const argsPartner = {
        partnerFName,
        partnerMidName,
        partnerLName,
        partnerState,
        partnerDist,
        partnerTaluk,
        partnerDOB,
        partnerCurrentAddress,
        partnerAge,
        partnerPhone,
        partnerMob1,
        partnerMob2,
        partnerPin,
      };
      const argsExperience = {
        otherExp,
      };
      const argsStorage = {
        strgFacility,
        transportFacility,
        godownSize,
      };
      const argsLogistics = {
        vehicleDetails: vehicalDetails,
      };
      const argsCapital = {
        investmentCapacity,
        workingCapital,
      };
      let crmLeadName = "";
      if (argsCurrent.fName) {
        crmLeadName += argsCurrent.fName;
      }
      if (argsCurrent.midName) {
        crmLeadName += " " + argsCurrent.midName;
      }
      if (argsCurrent.lName) {
        crmLeadName += " " + argsCurrent.lName;
      }

      const args = {
        crmLeadStatus: CRM_LEAD_STATUS.NEW_LEAD,
        activeStatus: "true",
        crmLeadId: -1,
        crmLeadName,
        customerTypeId: 1, // todo: hardcoded here
        capitalDetails: argsCapital,
        logisticsDetails: argsLogistics,
        storageDetails: argsStorage,
        experienceDetails: argsExperience,
        partnerDetails: argsPartner,
        companyDetails: argsCompany,
        educationDetails: argsEducational,
        personalDetails: argsPersonal,
        currentDetails: argsCurrent,
        areaId: areasRef.current.selectedValue.id,
      };
      // Validations
      if (!argsCurrent.fName || !argsCurrent.lName || !args.areaId) {
        COMMON_JS.showNotify(
          props,
          NOTIFY.WARNING,
          WARNINGS.PLEASE_FILL_MANDATORY_FIELDS
        );
        return;
      }
      const res = await CRM_APIs.manageCrmLeadProfile(args);
      console.log("manageCrmLeadProfile:", res);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        onClose();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, "Error: " + res.error);
      }
    } catch (error) {
      console.error("manageCrmLeadProfile: error:", error);
    }
  };

  console.log("selectedRow: ", selectedRow);

  return (
    <>
      <div
        className="formWrapper"
        style={{
          height: window.innerHeight * 0.7,
          overflow: "auto",
          paddingRight: "1rem",
        }}
      >
        <div className="formGroupBox">
          <div className="formGroupTitle">
            <h4>{LABELS.CURRENT_DETAILS}</h4>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"fName"}
                type={"text"}
                label={LABELS.FIRST_NAME}
                required={true}
                defaultValue={selectedRow.fName}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"midName"}
                type={"text"}
                label={LABELS.MIDDLE_NAME}
                // required={true}
                defaultValue={selectedRow.midName}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"lName"}
                type={"text"}
                label={LABELS.LAST_NAME}
                required={true}
                defaultValue={selectedRow.lName}
                //disabled={isSubmit}
              />
            </div>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"state"}
                type={"text"}
                label={LABELS.STATE}
                //required={true}
                defaultValue={selectedRow.state}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"district"}
                type={"text"}
                label={LABELS.DIST}
                //required={true}
                defaultValue={selectedRow.district}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"taluk"}
                type={"text"}
                label={LABELS.TALUKA}
                //required={true}
                defaultValue={selectedRow.taluk}
                //disabled={isSubmit}
              />
            </div>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"appDate"}
                type={"date"}
                label={LABELS.APPLICATION_DT}
                //required={true}
                defaultValue={selectedRow.appDate}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"dob"}
                type={"date"}
                label={LABELS.DOB}
                //required={true}
                defaultValue={selectedRow.dob}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"currentAdd"}
                type={"text"}
                label={LABELS.CURRENT_ADDRESS}
                //required={true}
                defaultValue={selectedRow.currentAdd}
                //disabled={isSubmit}
              />
            </div>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30 required">
              <label>
                {LABELS.AREA}
                <span>{" *"}</span>
              </label>
              <AutoComplete
                list={areas}
                childRef={areasRef}
                required={true}
                // defaultValue={{
                //   id: props.userInfo.empId,
                //   label: props.userInfo.empName,
                // }}
                // disabled={true}
              />
            </div>
            <div className="formGroup width30" />
            <div className="formGroup width30" />
          </div>
        </div>
        <div className="formGroupBox">
          <div className="formGroupTitle">
            <h4>{LABELS.PERSONAL_DETAILS}</h4>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"pState"}
                type={"text"}
                label={LABELS.PERSONAL_STATE}
                //required={true}
                defaultValue={selectedRow.pState}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"pDist"}
                type={"text"}
                label={LABELS.PERSONAL_DIST}
                // required={true}
                defaultValue={selectedRow.pDist}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"pTaluka"}
                type={"text"}
                label={LABELS.PERSONAL_TALUKA}
                // required={true}
                defaultValue={selectedRow.pTaluka}
                //disabled={isSubmit}
              />
            </div>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"phone"}
                type={"text"}
                label={LABELS.PHONE}
                //required={true}
                defaultValue={selectedRow.phone}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"mob1"}
                type={"text"}
                label={LABELS.MOB_1}
                //required={true}
                defaultValue={selectedRow.mob1}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"mob2"}
                type={"text"}
                label={LABELS.MOB_2}
                //required={true}
                defaultValue={selectedRow.mob2}
                //disabled={isSubmit}
              />
            </div>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"pin"}
                type={"number"}
                label={LABELS.PIN}
                //required={true}
                defaultValue={selectedRow.pin}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"age"}
                type={"number"}
                label={LABELS.AGE}
                //required={true}
                defaultValue={selectedRow.age}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30"></div>
          </div>
        </div>
        <div className="formGroupBox">
          <div className="formGroupTitle">
            <h4>{LABELS.COMPANY_DETAIL}</h4>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"compName"}
                type={"text"}
                label={LABELS.COMPANY_NAME}
                // required={true}
                defaultValue={selectedRow.compName}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"compEmail"}
                type={"text"}
                label={LABELS.COMPANY_EMAIL}
                //required={true}
                defaultValue={selectedRow.compEmail}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"compAddress"}
                type={"text"}
                label={LABELS.COMPANY_ADDRESS}
                // required={true}
                defaultValue={selectedRow.compAddress}
                //disabled={isSubmit}
              />
            </div>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"compState"}
                type={"text"}
                label={LABELS.COMPANY_STATE}
                //required={true}
                defaultValue={selectedRow.compState}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"compDist"}
                type={"text"}
                label={LABELS.COMPANY_DIST}
                //required={true}
                defaultValue={selectedRow.compDist}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"compTaluka"}
                type={"text"}
                label={LABELS.COMPANY_TALUKA}
                //required={true}
                defaultValue={selectedRow.compTaluka}
                //disabled={isSubmit}
              />
            </div>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"compPin"}
                type={"number"}
                label={LABELS.COMPANY_PIN}
                //required={true}
                defaultValue={selectedRow.compPin}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"firmType"}
                type={"text"}
                label={LABELS.FIRM_TYPE}
                //required={true}
                defaultValue={selectedRow.firmType}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"email"}
                type={"text"}
                label={LABELS.EMAIL_ID}
                //required={true}
                defaultValue={selectedRow.email}
                //disabled={isSubmit}
              />
            </div>
          </div>
        </div>
        <div className="formGroupBox">
          <div className="formGroupTitle">
            <h4>{LABELS.EDUCATIONAL_DETAILS}</h4>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"eduDetail"}
                type={"text"}
                label={LABELS.EDUCATIONAL_DETAILS}
                // required={true}
                defaultValue={selectedRow.eduDetail}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"eduSSC"}
                type={"text"}
                label={LABELS.EDUCATIONAL_SSC}
                //required={true}
                defaultValue={selectedRow.eduSSC}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"eduHSC"}
                type={"text"}
                label={LABELS.EDUCATIONAL_HSC}
                // required={true}
                defaultValue={selectedRow.eduHSC}
                //disabled={isSubmit}
              />
            </div>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"eduGraduationCert"}
                type={"text"}
                label={LABELS.EDUCATIONAL_GRADUATION_CIRTIFICATE}
                //required={true}
                defaultValue={selectedRow.eduGraduationCert}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"eduPostGraduationCert"}
                type={"text"}
                label={LABELS.EDUCATIONAL_POST_GRADUATION_CIRTIFICATE}
                //required={true}
                defaultValue={selectedRow.eduPostGraduationCert}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30"></div>
          </div>
        </div>
        <div className="formGroupBox">
          <div className="formGroupTitle">
            <h4>{LABELS.PARTNER_DETAIL}</h4>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"partnerFName"}
                type={"text"}
                label={LABELS.PARTNER_FIRST_NAME}
                // required={true}
                defaultValue={selectedRow.partnerFName}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"partnerMidName"}
                type={"text"}
                label={LABELS.PARTNER_MIDDLE_NAME}
                //required={true}
                defaultValue={selectedRow.partnerMidName}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"partnerLName"}
                type={"text"}
                label={LABELS.PARTNER_LAST_NAME}
                // required={true}
                defaultValue={selectedRow.partnerLName}
                //disabled={isSubmit}
              />
            </div>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"partnerState"}
                type={"text"}
                label={LABELS.PARTNER_STATE}
                //required={true}
                defaultValue={selectedRow.partnerState}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"partnerDist"}
                type={"text"}
                label={LABELS.PARTNER_DIST}
                //required={true}
                defaultValue={selectedRow.partnerDist}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"partnerTaluk"}
                type={"text"}
                label={LABELS.PARTNER_TALUKA}
                //required={true}
                defaultValue={selectedRow.partnerTaluk}
                //disabled={isSubmit}
              />
            </div>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"partnerDOB"}
                type={"date"}
                label={LABELS.PARTNER_DOB}
                //required={true}
                defaultValue={selectedRow.partnerDOB}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"partnerCurrentAddress"}
                type={"text"}
                label={LABELS.PARTNER_CURRENT_ADDRESS}
                //required={true}
                defaultValue={selectedRow.partnerCurrentAddress}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"partnerAge"}
                type={"number"}
                label={LABELS.PARTNER_AGE}
                //required={true}
                defaultValue={selectedRow.partnerAge}
                //disabled={isSubmit}
              />
            </div>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"partnerPhone"}
                type={"text"}
                label={LABELS.PARTNER_PHONE}
                //required={true}
                defaultValue={selectedRow.partnerPhone}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"partnerMob1"}
                type={"text"}
                label={LABELS.PARTNER_MOB_1}
                //required={true}
                defaultValue={selectedRow.partnerMob1}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"partnerMob2"}
                type={"text"}
                label={LABELS.PARTNER_MOB_2}
                //required={true}
                defaultValue={selectedRow.partnerMob2}
                //disabled={isSubmit}
              />
            </div>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"partnerPin"}
                type={"number"}
                label={LABELS.PARTNER_PIN}
                //required={true}
                defaultValue={selectedRow.partnerPin}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30"></div>
            <div className="formGroup width30"></div>
          </div>
        </div>
        <div className="formGroupBox">
          <div className="formGroupTitle">
            <h4>{LABELS.EXP_DETAILS}</h4>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"otherExp"}
                type={"text"}
                label={LABELS.OTHER_EXP}
                // required={true}
                defaultValue={selectedRow.otherExp}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30"></div>
            <div className="formGroup width30"></div>
          </div>
        </div>
        <div className="formGroupBox">
          <div className="formGroupTitle">
            <h4>{LABELS.STORAGE_DETAILS}</h4>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"strgFacility"}
                type={"text"}
                label={LABELS.STORAGE_FACILITY}
                // required={true}
                defaultValue={selectedRow.strgFacility}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"transportFacility"}
                type={"text"}
                label={LABELS.TRANSPORT_FACILITY}
                // required={true}
                defaultValue={selectedRow.transportFacility}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"godownSize"}
                type={"text"}
                label={LABELS.GODOWN_SIZE}
                // required={true}
                defaultValue={selectedRow.godownSize}
                //disabled={isSubmit}
              />
            </div>
          </div>
        </div>
        <div className="formGroupBox">
          <div className="formGroupTitle">
            <h4>{LABELS.LOGISTIC_DETAILS}</h4>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"vehicalDetails"}
                type={"text"}
                label={LABELS.VEHICAL_DETAILS}
                // required={true}
                defaultValue={selectedRow.vehicalDetails}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30"></div>
            <div className="formGroup width30"></div>
          </div>
        </div>
        <div className="formGroupBox">
          <div className="formGroupTitle">
            <h4>{LABELS.CAPITAL_DETAILS}</h4>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"investmentCapacity"}
                type={"text"}
                label={LABELS.INVESTMENT_CAPACITY}
                // required={true}
                defaultValue={selectedRow.investmentCapacity}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"workingCapital"}
                type={"text"}
                label={LABELS.WORKING_CAPITAL}
                // required={true}
                defaultValue={selectedRow.workingCapital}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30"></div>
          </div>
        </div>
      </div>
      {/* BtmMenu */}
      <div className="formGroup submitBtnWrapper">
        <div className="width30 flexRowAround">
          <Btn
            text={LABELS.SAVE}
            //loading={isSubmit}
            onClick={saveRrecord}
          />
          {/* <Btn
            text={LABELS.CANCEL}
            bgColor={COLORS.DIM_DARK_GRAY}
            onClick={() => setManageNewDialog(false)}
            //loading={isSubmit}
          /> */}
        </div>
      </div>
    </>
  );
};

export default withSnackbar(NewLeadProfile);
